import { render, staticRenderFns } from "./assignee-select.vue?vue&type=template&id=314d2236"
import script from "./assignee-select.vue?vue&type=script&lang=js"
export * from "./assignee-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports